import _ from 'lodash';
import classnames from 'classnames';
import React, { Component } from 'react';
import { Input } from 'antd';
import USER_EXAM_ITEM_STATUS from '@achievable-me/tundra-wizard/userExamItemStatus';
import { markdownToHtml } from '$lib/markdown';
import STEP from '$components/review/step';
import MODE from '$components/review/mode';
import styles from './styles.scss';

class QuizNumeric extends Component {
  onBlur = (e) => {
    e.preventDefault();

    const { handleInput } = this.props;
    const input = e.target.value;
    handleInput({ input });
  };

  onChange = (e) => {
    e.preventDefault();
    const { handleInput, mode } = this.props;

    // 20200523JP: Avoid pinging the server until they've finished entering their answer.
    if (mode === MODE.exam) {
      return;
    }

    const input = e.target.value;
    handleInput({ input });
  };

  renderInput = () => {
    const { quizState, quizObj } = this.props;
    const { step } = quizState;
    const { item, quiz } = quizObj;
    const { uuid: itemUuid, status } = item;
    const { input } = quiz;
    const choice = _.get(input, 's');

    const canInput = step === STEP.quizPrompt;

    const inputContainerClasses = classnames([
      styles.inputContainer,
      step === STEP.quizConfirmation &&
        status === USER_EXAM_ITEM_STATUS.correct &&
        styles.correct,
      step === STEP.quizConfirmation &&
        status !== USER_EXAM_ITEM_STATUS.correct &&
        styles.incorrect,
    ]);

    return (
      <div className={inputContainerClasses}>
        <div className={styles.instructions}>Input your answer</div>
        <Input
          key={itemUuid}
          disabled={!canInput}
          className={styles.inputField}
          defaultValue={choice}
          onBlur={this.onBlur}
          onChange={this.onChange}
        />
      </div>
    );
  };

  render() {
    const { quizObj } = this.props;
    const { quiz } = quizObj;
    const { prompt } = quiz;

    return (
      <div className={styles.layout}>
        <div className={styles.prompt}>{markdownToHtml(prompt)}</div>
        {this.renderInput()}
      </div>
    );
  }
}

export default QuizNumeric;
